"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _List = babelHelpers.interopRequireDefault(require("./List"));

var _Listener = babelHelpers.interopRequireDefault(require("./Listener"));

var _Viewer = babelHelpers.interopRequireDefault(require("./Viewer"));

var _base = require("modals/base");

var _class, _descriptor, _temp;

var NotificationModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(NotificationModal, _ReactModal);

  function NotificationModal(notifications, hasMore, showMore) {
    var _this;

    babelHelpers.classCallCheck(this, NotificationModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(NotificationModal).call(this));
    _this._update = 0;
    _this.removeOnHide = true;

    _this.setComponent(_react.default.createElement(_List.default, {
      limit: 10,
      notifications: notifications,
      open: true,
      hasMore: hasMore,
      showMore: showMore,
      updateNr: _this._update++
    }));

    return _this;
  }

  babelHelpers.createClass(NotificationModal, [{
    key: "updateNotifications",
    value: function updateNotifications(notifications, hasMore, showMore) {
      this.setComponent(_react.default.createElement(_List.default, {
        limit: 10,
        notifications: notifications,
        open: true,
        hasMore: hasMore,
        showMore: showMore,
        updateNr: this._update++
      }));
    }
  }, {
    key: "icon",
    get: function get() {
      return '<span class="material-icons" data-icon="notifications_none"></span>';
    }
  }, {
    key: "title",
    get: function get() {
      return 'Notifications';
    }
  }]);
  return NotificationModal;
}(_base.ReactModal);

var NotificationButton = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(NotificationButton, _Component);

  function NotificationButton() {
    var _babelHelpers$getProt;

    var _this2;

    babelHelpers.classCallCheck(this, NotificationButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(NotificationButton)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "notificationButton", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      notifications: {
        newCount: 0
      },
      showNotification: null,
      open: null,
      isMobile: false
    };
    _this2.componentIsMounted = false;
    _this2.mq = null;
    return _this2;
  }

  babelHelpers.createClass(NotificationButton, [{
    key: "showNotifications",
    value: function showNotifications(event) {
      var _this3 = this;

      event.preventDefault();

      if (this.state.isMobile) {
        var hasMore = _Listener.default.feed.nextPage != null;
        var showMore = this.showMore;
        this.notificationModal = new NotificationModal(this.state.notifications, hasMore, showMore);
        this.notificationModal.show().then(function (element) {
          $(element).on('hidden.bs.modal', function (event) {
            _this3.notificationModal = null;
          });
        });
      } else {
        this.setState({
          open: true
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "mqListener",
    value: function mqListener(mediaQuery) {
      this.setState({
        isMobile: mediaQuery.matches
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _Listener.default.addEventListener('feedUpdated', this.feedUpdated);

      _Listener.default.addEventListener('openNotification', this.doShowNotification);

      this.componentIsMounted = true;

      if (window.matchMedia) {
        this.mq = window.matchMedia('(max-width: 767px)');
        this.mq.addListener(this.mqListener);
        this.mqListener(this.mq);
      } // If there's a 'notification' parameter in the URL, open that notification.


      var p = location.search.substring(1).split('&').concat(location.hash.substring(1).split('&')).filter(function (v) {
        return !!v;
      }).map(function (v) {
        return v.split('=').map(decodeURIComponent);
      }).map(function (_ref) {
        var _ref2 = babelHelpers.toArray(_ref),
            key = _ref2[0],
            value = _ref2.slice(1);

        return [key, value.join('=')];
      }).reduce(function (acc, _ref3) {
        var _ref4 = babelHelpers.slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        acc[key] = value;
        return acc;
      }, {});

      if (p.notification) {
        this.setState({
          showNotification: p.notification
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this4 = this;

      if (this.state.showNotification && this.state.notifications && this.state.notifications.feed) {
        var item = this.state.notifications.feed.filter(function (item) {
          return item.id == _this4.state.showNotification;
        })[0];

        if (item) {
          this.setState({
            showNotification: null
          });
          var V = new _Viewer.default();
          V.setNotifications(this.state.notifications, this.state.showNotification);
          V.show();
        }
      }

      if (this.notificationModal) {
        var hasMore = _Listener.default.feed.nextPage != null;
        var showMore = this.showMore;
        this.notificationModal.updateNotifications(this.state.notifications, hasMore, showMore);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _Listener.default.removeEventListener('feedUpdated', this.feedUpdated);

      _Listener.default.removeEventListener('openNotification', this.doShowNotification);

      if (this.mq) {
        this.mq.removeListener(this.mqListener);
        this.mq = null;
      }

      this.componentIsMounted = false;
    }
  }, {
    key: "feedUpdated",
    value: function feedUpdated(_ref5) {
      var data = _ref5.data;
      this.setState({
        notifications: data
      });
    }
  }, {
    key: "doShowNotification",
    value: function doShowNotification(_ref6) {
      var data = _ref6.data;
      this.setState({
        showNotification: data
      });
    }
  }, {
    key: "showMore",
    value: function showMore() {
      _Listener.default.fetchMore();
    }
  }, {
    key: "render",
    value: function render() {
      var hasMore = _Listener.default.feed && _Listener.default.feed.nextPage != null;
      var showMore = this.showMore;
      return _react.default.createElement("div", {
        className: "notification-container"
      }, _react.default.createElement("a", {
        title: "Notifications",
        className: _classList.default.join('icon', 'notifications', this.state.notifications.newCount ? 'pulse' : ''),
        href: "javascript:void(0)",
        onClick: !this.state.open ? this.showNotifications : this.close
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "notifications_none"
      }), _react.default.createElement("span", {
        className: "sr-only"
      }, "Notifications")), !this.state.isMobile && _react.default.createElement(_List.default, {
        limit: 10,
        notifications: this.state.notifications,
        open: this.state.open,
        closePanel: this.close,
        hasMore: hasMore,
        showMore: showMore
      }));
    }
  }]);
  return NotificationButton;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "notificationButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showNotifications", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showNotifications"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "close", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "mqListener", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "mqListener"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "feedUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "feedUpdated"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doShowNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doShowNotification"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showMore", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showMore"), _class.prototype)), _class);
exports.default = NotificationButton;